import React, { useEffect, useRef, useState } from 'react';

import CommonImage from '@components/CommonImage';

import SelectColor from '@features/assets/components/CommonComponents/SelectColor';

import { addColorsToMaterial } from '@services/materialService';

import { materialColortabs } from '@utils/MaterialsUtil';

const MaterialColorAddV2 = ({
	colorId,
	colorDTO,
	setColorDTO,
	colorType,
	setColorType,
	colorGroupIdList,
	setColorGroupIdList,
	selectedGroupColorList,
	setSelectedGroupColorList,
	selectedPantoneColorList,
	setSelectedPantoneColorList,
	isShowSubmit = false,
	materialId = null,
	actionSuccess = () => {},
	renderFrom = ''
}) => {
	const [, setPantoneColorIds] = useState([]);
	const [isMultiSelect, setIsMultiSelect] = useState(false);
	const [showColorPopup, setShowColorPopup] = useState(false);
	const colorDropdownRef = useRef();

	const onOutSideClick = (e) => {
		let selectedElement = e.target;
		if (colorDropdownRef.current && !colorDropdownRef.current.contains(selectedElement)) {
			setShowColorPopup(false);
		}
	};

	useEffect(() => {
		document.addEventListener('click', onOutSideClick, { capture: true });
		return () => {
			document.removeEventListener('click', onOutSideClick, { capture: true });
		};
	}, []);

	useEffect(() => {
		if (colorType === 'SOLID') {
			setIsMultiSelect(false);
		} else {
			setIsMultiSelect(true);
		}
	}, [colorType]);

	useEffect(() => {
		if (colorType) {
			if (colorType === 'SOLID') {
				if (selectedPantoneColorList?.length > 0) {
					const selectedColor = selectedPantoneColorList[0];
					setColorDTO({
						colorType: 'SOLID',
						representedBy: 'PANTONE_OR_HEX_CODE',
						id: colorId || null,
						name: selectedColor?.name,
						pantoneColorId: selectedColor?.pantoneColorId
					});
				} else {
					setColorDTO(null);
				}
			} else {
				if (selectedPantoneColorList?.length > 0) {
					setColorDTO({
						colorType: colorType,
						representedBy: 'PANTONE_OR_HEX_CODE',
						id: colorId || null,
						name: colorType,
						compositeColorList: selectedPantoneColorList?.map((color) => ({
							id: color?.id,
							name: color?.name,
							code: color?.code,
							hexCode: color?.hexCode
						}))
					});
				} else {
					setColorDTO(null);
				}
			}
		}
	}, [colorType, selectedPantoneColorList]);

	const handleTabChange = (tabName) => {
		setColorType(tabName);
		setSelectedGroupColorList([]);
		setSelectedPantoneColorList([]);
		if (tabName !== 'Solid') {
			setIsMultiSelect(true);
		}
	};

	const renderSelectedColors = () => {
		if (selectedPantoneColorList?.length > 0) {
			return selectedPantoneColorList?.map((item) => (
				<li className="d-flex justify-content-start align-items-center" key={`key_${item?.id}`}>
					<span
						className="color-icon mr-1"
						style={{
							background: item?.hexCode
						}}
					/>
					<span className="code gray_dark_02 regular-14">{item?.code}</span>
				</li>
			));
		} else {
			return selectedGroupColorList?.map((item) => (
				<li className="d-flex justify-content-start align-items-center" key={`key_${item?.id}`}>
					<span
						className="color-icon mr-1"
						style={{
							background: item?.hexCode
						}}
					/>
					<span className="code gray_dark_02 regular-14">{item?.code || item?.name}</span>
				</li>
			));
		}
	};

	const onAddColorToMaterial = async () => {
		const responseData = await addColorsToMaterial(colorDTO, materialId, colorGroupIdList, colorType);
		if (responseData) {
			actionSuccess();
			setShowColorPopup(false);
		}
	};

	const isTCXColorDisabled = () => {
		return selectedGroupColorList?.some((color) => color.isTransparent === true);
	};

	return (
		<div className="material-color-add-v2" ref={renderFrom !== 'DESIGN' ? colorDropdownRef : null}>
			<div className="select-component color-select-dropdown chip-component mb-3">
				{!isShowSubmit ? (
					<>
						<label htmlFor="collection">Color*</label>
						<div
							className="click-box text-right click mb-1"
							onClick={() => setShowColorPopup((prev) => !prev)}
						>
							<div className="all-color-code">
								<ul className="d-flex gap-1 flex-wrap">{renderSelectedColors()}</ul>
							</div>
						</div>{' '}
					</>
				) : (
					<button
						className="button text-only add-new-colors"
						onClick={() => setShowColorPopup((prev) => !prev)}
					>
						<CommonImage src={'/icons/Add.svg'} alt={'add'} />
					</button>
				)}

				<div className={`material-color-dropdown-wrapper ${showColorPopup ? 'show' : ''}`}>
					<div className="d-flex justify-content-between">
						<label htmlFor="colorSelect" className="text-left mb-1">
							Select Color
						</label>
						<div>
							<CommonImage
								src={'/icons/close.svg'}
								alt={'add'}
								onClick={() => setShowColorPopup(false)}
								className={'cursor-pointer'}
							/>
						</div>
					</div>
					<div className="color-type-tab inner-tabs mb-3">
						<ul>
							{Object.entries(materialColortabs).map(([key, name]) => (
								<li
									key={key}
									className={colorType === key ? 'active' : ''}
									onClick={() => handleTabChange(key)}
								>
									{name}
								</li>
							))}
						</ul>
					</div>
					<div className="mb-2">
						<SelectColor
							selectedColorList={selectedGroupColorList}
							setSelectedColorList={setSelectedGroupColorList}
							setPantoneColorIds={setColorGroupIdList}
							isShowLabel={false}
							isMultiple={isMultiSelect}
							placeholder={'Select main color'}
							colorType={'group'}
							selectedColorType={colorType}
						/>
					</div>
					<div>
						<SelectColor
							selectedColorList={selectedPantoneColorList}
							setSelectedColorList={setSelectedPantoneColorList}
							setPantoneColorIds={setPantoneColorIds}
							isShowLabel={false}
							isMultiple={isMultiSelect}
							placeholder={'Select TCX color'}
							colorType={'pantone'}
							isDisabled={isTCXColorDisabled()}
						/>
					</div>
					{isShowSubmit && (
						<div>
							<button
								type="button"
								className="button size32 w-100"
								onClick={() => onAddColorToMaterial()}
								disabled={!selectedGroupColorList?.length}
							>
								Submit
							</button>
						</div>
					)}
				</div>
			</div>
		</div>
	);
};

export default MaterialColorAddV2;
